import React from 'react';
import PropTypes from 'prop-types';
import { NAME_ERRORS, validateName } from '@Utils/Name';
import ProfileSettingsInputSection from '@Pages/ProfileSettings/Components/ProfileSettingsInputSection';

const createInputErrorsMessages = (label, maxLength, minLength) => ({
  [NAME_ERRORS.MIN_LENGTH]: `${label} must have minimum of ${minLength} characters.`,
  [NAME_ERRORS.MAX_LENGTH]: `${label} must have maximum of ${maxLength} characters.`,
  [NAME_ERRORS.CHECK_ASCII]: `${label} must contain only ASCII characters.`,
});

function InputSection({ name, label, value, onChange, onSave, onClose, onBlur, title, maxLength, minLength, isRequired }) {
  const inputErrorsMessages = createInputErrorsMessages(label, maxLength, minLength);
  // eslint-disable-next-line no-shadow
  const validateInput = (value) => validateName(value, maxLength, minLength, isRequired);
  return (
    <ProfileSettingsInputSection
      name={name}
      label={label}
      title={title}
      value={value}
      errorsMessages={inputErrorsMessages}
      validate={validateInput}
      onChange={onChange}
      onSave={onSave}
      onClose={onClose}
      onBlur={onBlur}
    />
  );
}

InputSection.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  isRequired: PropTypes.bool,
};

export default InputSection;
